import { atom } from 'jotai';
import { IUserDetail, TArticleDetail, TComment } from 'shared/models';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface ImmersiveArticleData {
  article: TArticleDetail;
  author: IUserDetail;
  comments: TComment[];
}

type TArticleRelatedPostStore = { [key: string]: Promise<ImmersiveArticleData[]> | ImmersiveArticleData[] | undefined };

const $ArticleImmersiveRelatedPostStore = atom<TArticleRelatedPostStore>({});

export const $ArticleImmersiveRelatedPost = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleImmersiveRelatedPostStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: ImmersiveArticleData[] | Promise<ImmersiveArticleData[]>) => {
      const old = get($ArticleImmersiveRelatedPostStore);
      set($ArticleImmersiveRelatedPostStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleImmersiveRelatedPost+${encodeURIComponent(groupId)}`;

  return a;
});
